export default __webpack_public_path__ + "file-asset/d8c3dc7665947e9be8a151bf41e26e89-CarsonLogo.svg";